import { render, staticRenderFns } from "./DifferenceIndicator.vue?vue&type=template&id=7c94919a&scoped=true&"
import script from "./DifferenceIndicator.vue?vue&type=script&lang=js&"
export * from "./DifferenceIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c94919a",
  null
  
)

export default component.exports